import { ProtocolCommand } from '../service-model/protocol-command.interface';
import { TelemetryEvent } from './telementry-event.class';

export class LogEvent implements ProtocolCommand {
  constructor(public events: TelemetryEvent[]) {}
  getOperationName(): string {
    return 'ETS.TelemetryService.Protocol.LogEvent';
  }
}